import React from 'react'
import { Outlet } from 'react-router-dom'
import HeaderPage from '../HeadFoot/HeaderPage/HeaderPage'
import FooterPage from '../HeadFoot/FooterPage/FooterPage'

const RootLayout = () => {
  return (
    <div>
      <HeaderPage />
      <Outlet />
      <FooterPage/>
    </div>
  )
}

export default RootLayout